// @ts-nocheck

export const localeCodes =  [
  "nl"
]
export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_46json_4206e3cd",
      load: () => import("#nuxt-i18n/4206e3cd" /* webpackChunkName: "locale_nl_46json_4206e3cd" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "nl",
    name: "Nederlands",
    language: undefined
  }
]

